import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { DeviceType } from './devicetype';
import { DeviceTypeService } from '../../services/devicetype.service';
import { ApiResponse } from '../../admin/apiresponse';
import { Observable, Subscription } from 'rxjs';

@Component({
    //selector: 'devicetype',
    template: require('./admin.devicetype.list.component.html'),
    providers: [DeviceTypeService]
})

export class DeviceTypeListComponent implements OnInit {

    public queryInProgress: boolean;
    public deleteInProgress: boolean;
    public apiResponse: ApiResponse;
    public deviceTypes: DeviceType[] = [];
    public busySub: Subscription;
    public deleteDeviceTypeSub: Subscription;
    public getDetailsSub: Subscription;
    public selectedDeviceType: any;
    public editIndex: number = -1;
    public testGroupFilterModes: string[];
    public versionSelectionModes: string[];
    public urlExpirationValues: string[];
    showDialog = false;

    constructor(private devicetypeService: DeviceTypeService) {

    }

    ngOnInit() {
        this.queryInProgress = true;
        this.getDeviceTypes();
        this.initiliazeValues();
    }

    initiliazeValues() {
        this.devicetypeService.getVersionSelectionModes()
            .subscribe(
            success => {
                this.versionSelectionModes = success.data;
            },
            error => this.handleError(<any>error)
            );
        this.devicetypeService.getTestGroupFilterModes()
            .subscribe(
            success => {
                this.testGroupFilterModes = success.data;
            },
            error => this.handleError(<any>error)
            );

        this.devicetypeService.getUrlExpirationValues()
            .subscribe(
            success => {
                this.urlExpirationValues = success.data;
            },
            error => this.handleError(<any>error)
            );
    }

    getDeviceTypes() {
        this.deviceTypes = [];
        this.busySub = this.devicetypeService.getDeviceTypes()
            .subscribe(
            success => {
                this.setGetResponse(success);
            },
            error => {
                console.error(JSON.stringify(error));
            }
            );
    }

    deviceTypeSelected(grid: any, rowIndex: number) {
        this.selectedDeviceType = null;
        this.editIndex = -1;
        this.getDetailsSub = this.devicetypeService.getDeviceType(grid.data.Name)
            .subscribe(
            success => {
                this.selectedDeviceType = success.data;
                //this.selectedDeviceType.rowIndex = rowIndex;
            },
            error => console.error(JSON.stringify(error))
            );


    }

    //deleteDeviceType(deviceTypeName: string) {
    //    this.deleteInProgress = true;
    //    this.deleteDeviceTypeSub = this.devicetypeService.deleteDeviceType(deviceTypeName)
    //        .subscribe(
    //        success => this.setDeleteResponse(success, deviceTypeName),
    //        error => console.error(JSON.stringify(error))
    //    );           
    //}

    setGetResponse(resp: ApiResponse) {
        this.queryInProgress = false;
        this.apiResponse = resp;
        this.deviceTypes = resp.data || [];
    }

    setDeleteResponse(resp: ApiResponse, deviceTypeName: string) {
        this.deleteInProgress = false;
        this.apiResponse = resp;
        if (resp.statusCode === 204) {
            this.getDeviceTypes();
        }
    }

    public editDeviceType(id: number) {
        this.editIndex = 999;// this.selectedAsset.rowIndex;
        //this.defaultReleaseState = this.selectedAsset.ReleaseState;
    }

    public cancelEditDeviceType(id: number) {
        this.editIndex = -1;
    }

    public updateDeviceType(deviceType: DeviceType) {
        var currentAsset = this.selectedDeviceType;
        //currentAsset.ReleaseState = this.defaultReleaseState;


        this.busySub = this.devicetypeService.updateDeviceType(deviceType)
            .finally(() => {
                this.editIndex = -1;
            })
            .subscribe(
            success => {
                //currentAsset.ReleaseState = this.defaultReleaseState;
                this.editIndex = -1;
                this.getDeviceTypes();
            },
            error => {
                this.handleError(error);
                //this.editIndex = -1;
            });
    }

    showDeleteConfirmDialog(index: number, deviceTypeName: string) {
        //this.selectedDeviceType = this.deviceTypes.find(x => x.name === deviceTypeName);
        //this.selectedDeviceType.Index = index;
        this.showDialog = true;
    }

    deleteDeviceType(deviceTypeName: string) {
        this.showDialog = false;
        this.deleteDeviceTypeSub = this.devicetypeService.deleteDeviceType(deviceTypeName)
            .subscribe(
            success => {
                this.setDeleteResponse(success, deviceTypeName);
                this.editIndex = -1;
                this.getDeviceTypes();
                this.selectedDeviceType = null;
            },
            error => {
                console.error(JSON.stringify(error));
                this.editIndex = -1;
            }
            );
    }

    private handleError(resp: any) {
        console.log(resp);
    }
}


// WEBPACK FOOTER //
// ./app/admin/devicetype/admin.devicetype.list.component.ts